// Minimal grids keep optional controls in AG Grid's native context menu.
export function configureMinimalGrid(options, element) {
  if (options.grid_type !== 'minimal') return;
  const root = element.closest('.grid-refresh-container');
  const columns = (defs, change) => defs.map(def => def.children
    ? { ...def, children: columns(def.children, change) }
    : { ...def, ...change });
  let filtersVisible = options.floatingFiltersHeight !== 0;

  const setFilters = (api, enabled) => {
    filtersVisible = enabled;
    api.setFilterModel(null);
    api.setAdvancedFilterModel(null);
    api.updateGridOptions({
      enableAdvancedFilter: false,
      floatingFiltersHeight: enabled ? 20 : 0,
      columnDefs: columns(api.getColumnDefs(), { floatingFilter: enabled }),
    });
  };
  options.getContextMenuItems = ({ api }) => {
    const groups = api.getRowGroupColumns();
    const footers = Boolean(api.getGridOption('grandTotalRow'));
    const items = [
      {
        name: 'Group By',
        subMenu: api.getColumns().filter(col => col.isAllowRowGroup()).map(col => ({
          name: api.getDisplayNameForColumn(col, 'columnToolPanel'),
          checked: groups.includes(col),
          action: () => {
            const next = groups.includes(col) ? groups.filter(item => item !== col) : [...groups, col];
            api.setRowGroupColumns(next);
            api.setGridOption('rowGroupPanelShow', next.length ? 'always' : 'never');
          },
        })),
      },
      {
        name: filtersVisible ? 'Hide Column Filters' : 'Show Column Filters',
        checked: filtersVisible,
        action: () => setFilters(api, !filtersVisible),
      },
      {
        name: 'Footers', checked: footers,
        action: () => api.updateGridOptions({
          grandTotalRow: footers ? undefined : 'bottom',
          groupTotalRow: footers ? undefined : 'bottom',
        }),
      },
      'separator',
    ];
    if (options.excelExport !== false) {
      const printForm = root.querySelector('[id^="printFormButton-"]');
      items.push({ name: 'Export Options', subMenu: [
        { name: 'Excel', action: () => api.exportDataAsExcel() },
        { name: 'Excel (Legacy)', action: () => api.exportDataAsExcel() },
        { name: 'CSV', action: () => api.exportDataAsCsv() },
        { name: 'Export To', disabled: !printForm || printForm.disabled, action: () => printForm.click() },
      ] });
    }
    items.push(
      { name: 'Expand All', disabled: !groups.length, action: () => api.expandAll() },
      { name: 'Collapse All', disabled: !groups.length, action: () => api.collapseAll() },
      'separator',
      {
        name: 'Reset Filters', action: () => {
          api.setFilterModel(null);
          api.setAdvancedFilterModel(null);
          api.onFilterChanged();
        },
      },
    );
    return items;
  };
}
